import { generateClient } from 'aws-amplify/data'

const client = generateClient({
  authMode: 'userPool'
})

export const merchantService = {
  async list() {
    const { data, errors } = await (client.models as any).Merchant.list()
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async get(id: string) {
    const { data, errors } = await (client.models as any).Merchant.get({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async create(input: any) {
    const { data, errors } = await (client.models as any).Merchant.create(input)
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async update(id: string, input: any) {
    const { data, errors } = await (client.models as any).Merchant.update({ id, ...input })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async delete(id: string) {
    const { data, errors } = await (client.models as any).Merchant.delete({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async findByEmail(email: string) {
    const { data, errors } = await (client.models as any).Merchant.list({
      filter: { email: { eq: email } }
    })
    if (errors) throw new Error(errors[0].message)
    return data[0] || null
  },

  async sendOTP(phoneOrEmail: string) {
    const { data, errors } = await (client.queries as any).sendOTPProcessor({
      phoneNumber: phoneOrEmail
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async verifyOTP(phoneOrEmail: string, code: string) {
    const { data, errors } = await (client.models as any).Otp.list({
      filter: {
        phoneNumber: { eq: phoneOrEmail },
        otp: { eq: code },
        status: { eq: 'PENDING' },
        expiryTime: { gt: new Date().toISOString() }
      }
    })
    if (errors) throw new Error(errors[0].message)
    
    if (data && data.length > 0) {
      const otpRecord = data[0]
      await (client.models as any).Otp.delete({ id: otpRecord.id })
      return true
    }
    return false
  },

  async updateVerification(id: string, field: 'email' | 'phone') {
    const updateData = field === 'email' 
      ? { emailVerified: true } 
      : { phoneVerified: true }
    
    const { data, errors } = await (client.models as any).Merchant.update({ id, ...updateData })
    if (errors) throw new Error(errors[0].message)
    return data
  }
}

export const businessService = {
  async list() {
    const { data, errors } = await (client.models as any).Business.list()
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async get(id: string) {
    const { data, errors } = await (client.models as any).Business.get({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async create(input: any) {
    const { data, errors } = await (client.models as any).Business.create(input)
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async update(id: string, input: any) {
    const { data, errors } = await (client.models as any).Business.update({ id, ...input })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async delete(id: string) {
    const { data, errors } = await (client.models as any).Business.delete({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async listByMerchant(merchantId: string) {
    const { data, errors } = await (client.models as any).Business.list({
      filter: { merchantId: { eq: merchantId } }
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async sendOTP(phoneOrEmail: string) {
    const { data, errors } = await (client.queries as any).sendOTPProcessor({
      phoneNumber: phoneOrEmail
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async verifyOTP(phoneOrEmail: string, code: string) {
    const { data, errors } = await (client.models as any).Otp.list({
      filter: {
        phoneNumber: { eq: phoneOrEmail },
        otp: { eq: code },
        status: { eq: 'PENDING' },
        expiryTime: { gt: new Date().toISOString() }
      }
    })
    if (errors) throw new Error(errors[0].message)
    
    if (data && data.length > 0) {
      const otpRecord = data[0]
      await (client.models as any).Otp.delete({ id: otpRecord.id })
      return true
    }
    return false
  },

  async updateVerification(id: string, field: 'email' | 'phone') {
    const updateData = field === 'email' 
      ? { emailVerified: true } 
      : { phoneVerified: true }
    
    const { data, errors } = await (client.models as any).Business.update({ id, ...updateData })
    if (errors) throw new Error(errors[0].message)
    return data
  }
}

export const advertisementService = {
  async list() {
    const { data, errors } = await (client.models as any).Advertisement.list()
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async get(id: string) {
    const { data, errors } = await (client.models as any).Advertisement.get({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async create(input: any) {
    const { data, errors } = await (client.models as any).Advertisement.create(input)
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async update(id: string, input: any) {
    const { data, errors } = await (client.models as any).Advertisement.update({ id, ...input })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async delete(id: string) {
    const { data, errors } = await (client.models as any).Advertisement.delete({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async listByMerchant(merchantId: string) {
    const { data, errors } = await (client.models as any).Advertisement.list({
      filter: { merchantId: { eq: merchantId } }
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async listByBusiness(businessId: string) {
    const { data, errors } = await (client.models as any).Advertisement.list({
      filter: { businessId: { eq: businessId } }
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async listPending() {
    const { data, errors } = await (client.models as any).Advertisement.list({
      filter: { approvalStatus: { eq: 'PENDING' } }
    })
    if (errors) throw new Error(errors[0].message)
    return data
  }
}

export const locationDataService = {
  async list() {
    const { data, errors } = await (client.models as any).LocationData.list()
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async listUserLocations() {
    const { data, errors } = await (client.models as any).LocationData.list({
      filter: {
        contextType: { eq: 'DIRECT' },
        isVisible: { eq: true },
        shareCurrentLocation: { eq: true }
      }
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async getLocationsInRadius(centerLat: number, centerLng: number, radiusKm: number) {
    const allLocations = await this.listUserLocations()
    
    return allLocations.filter((location: any) => {
      if (!location.lat || !location.long) return false
      
      const distance = this.calculateDistance(
        centerLat,
        centerLng,
        location.lat,
        location.long
      )
      
      return distance <= radiusKm
    })
  },

  calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371
    const dLat = this.deg2rad(lat2 - lat1)
    const dLon = this.deg2rad(lon2 - lon1)
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    return R * c
  },

  deg2rad(deg: number): number {
    return deg * (Math.PI / 180)
  }
}

export const userService = {
  async list() {
    const { data, errors } = await (client.models as any).User.list()
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async get(id: string) {
    const { data, errors } = await (client.models as any).User.get({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async update(id: string, input: any) {
    const { data, errors } = await (client.models as any).User.update({ id, ...input })
    if (errors) throw new Error(errors[0].message)
    return data
  }
}

export const adminService = {
  async list() {
    const { data, errors } = await (client.models as any).Admin.list()
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async get(id: string) {
    const { data, errors } = await (client.models as any).Admin.get({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async create(input: any) {
    const { data, errors } = await (client.models as any).Admin.create(input)
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async update(id: string, input: any) {
    const { data, errors } = await (client.models as any).Admin.update({ id, ...input })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async delete(id: string) {
    const { data, errors } = await (client.models as any).Admin.delete({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async findByEmail(email: string) {
    const { data, errors } = await (client.models as any).Admin.list({
      filter: { email: { eq: email } }
    })
    if (errors) throw new Error(errors[0].message)
    return data[0] || null
  }
}

export const creditPurchaseService = {
  async list() {
    const { data, errors } = await (client.models as any).CreditPurchase.list()
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async get(id: string) {
    const { data, errors } = await (client.models as any).CreditPurchase.get({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async create(input: any) {
    const { data, errors } = await (client.models as any).CreditPurchase.create(input)
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async update(id: string, input: any) {
    const { data, errors } = await (client.models as any).CreditPurchase.update({ id, ...input })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async listByMerchant(merchantId: string) {
    const { data, errors } = await (client.models as any).CreditPurchase.list({
      filter: { merchantId: { eq: merchantId } }
    })
    if (errors) throw new Error(errors[0].message)
    return data
  }
}

export const merchantNotificationService = {
  async list() {
    const { data, errors } = await (client.models as any).MerchantNotification.list()
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async get(id: string) {
    const { data, errors } = await (client.models as any).MerchantNotification.get({ id })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async create(input: any) {
    const { data, errors } = await (client.models as any).MerchantNotification.create(input)
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async update(id: string, input: any) {
    const { data, errors } = await (client.models as any).MerchantNotification.update({ id, ...input })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async listByMerchant(merchantId: string) {
    const { data, errors } = await (client.models as any).MerchantNotification.list({
      filter: { merchantId: { eq: merchantId } }
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async markAsRead(id: string) {
    const { data, errors } = await (client.models as any).MerchantNotification.update({
      id,
      isRead: true
    })
    if (errors) throw new Error(errors[0].message)
    return data
  }
}

export const adInteractionService = {
  async list() {
    const { data, errors } = await (client.models as any).AdInteraction.list()
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async create(input: any) {
    const { data, errors } = await (client.models as any).AdInteraction.create(input)
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async listByAdvertisement(advertisementId: string) {
    const { data, errors } = await (client.models as any).AdInteraction.list({
      filter: { advertisementId: { eq: advertisementId } }
    })
    if (errors) throw new Error(errors[0].message)
    return data
  }
}

export const reportService = {
  async list(filters?: any) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'GET_REPORTS',
      filters: JSON.stringify(filters || {})
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async get(reportId: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'GET_REPORT_DETAILS',
      reportId: reportId
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async assignToMe(reportId: string, adminId: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'ASSIGN_TO_ME'
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async changeStatus(reportId: string, adminId: string, newStatus: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'CHANGE_STATUS',
      actionData: JSON.stringify({ newStatus })
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async changePriority(reportId: string, adminId: string, newPriority: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'CHANGE_PRIORITY',
      actionData: JSON.stringify({ newPriority })
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async addNote(reportId: string, adminId: string, notes: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'ADD_NOTE',
      actionData: JSON.stringify({ notes })
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async warnUser(reportId: string, adminId: string, warningMessage: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'WARN_USER',
      actionData: JSON.stringify({ warningMessage })
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async suspendUser(reportId: string, adminId: string, suspensionDays: number, reason: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'SUSPEND_USER',
      actionData: JSON.stringify({ suspensionDays, reason })
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async banUser(reportId: string, adminId: string, reason: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'BAN_USER',
      actionData: JSON.stringify({ reason })
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async removeContent(reportId: string, adminId: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'REMOVE_CONTENT'
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async dismiss(reportId: string, adminId: string, reason: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'DISMISS',
      actionData: JSON.stringify({ reason })
    })
    if (errors) throw new Error(errors[0].message)
    return data
  },

  async resolve(reportId: string, adminId: string, resolutionAction: string, resolutionNotes: string) {
    const { data, errors } = await (client.queries as any).sendEmailProcessor({
      adminAction: 'UPDATE_REPORT',
      reportId: reportId,
      adminId: adminId,
      actionType: 'RESOLVE',
      actionData: JSON.stringify({ resolutionAction, resolutionNotes })
    })
    if (errors) throw new Error(errors[0].message)
    return data
  }
}

export const queryService = {
  async bulkNotificationProcessor(input: {
    userIds: string[]
    pushTitle?: string
    pushBody?: string
    pushData?: string
    createDbRecord?: boolean
    notificationType?: string
    referenceType?: string
    referenceId?: string
    metadata?: string
  }) {
    const { data, errors } = await (client.queries as any).bulkNotificationProcessor(input)
    if (errors) throw new Error(errors[0].message)
    return data
  }
}